import service from "@irati-tracking/tracker"

const tracking = {}

tracking.viewGetStarted = () => {
  service.trackMedicalEvent("medical_view_get_started")
}

tracking.viewStep = (step: number, activationCode = null) => {
  service.trackMedicalEvent("medical_view_step", {step, activationCode})
}

tracking.detailsSubmitted = (activationCode: string) => {
  service.trackMedicalEvent("medical_details_submitted", {activationCode})
}

tracking.textRequested = (activationCode: string, page: string) => {
  service.trackMedicalEvent("medical_text_requested", {activationCode, page})
}

tracking.viewHome = (activationCode: string) => {
  service.trackMedicalEvent("medical_view_home", {activationCode})
}

tracking.viewMoreInfo = (activationCode: string, name: string) => {
  service.trackMedicalEvent("medical_view_more_info", {activationCode, name})
}

tracking.downloadPolicy = (activationCode: string, name: string) => {
  service.trackMedicalEvent("medical_download_policy", {activationCode, name})
}

tracking.downloadCertificate = (activationCode: string) => {
  service.trackMedicalEvent("medical_download_certificate", {activationCode})
}

tracking.makeClaim = (activationCode: string) => {
  service.trackMedicalEvent("medical_make_claim", {activationCode})
}

tracking.viewVideo = (tier: string) => {
  service.trackMedicalEvent("medical_view_video", {tier})
}

tracking.viewReports = () => {
  service.trackMedicalEvent("medical_view_reports")
}

tracking.downloadReport = (trackingEventName: string) => {
  service.trackMedicalEvent(trackingEventName)
}

tracking.continueOnline = (activationCode: string, page: string) => {
  service.trackMedicalEvent("medical_continue_web", {activationCode, page})
}

tracking.viewStepApp = (step: number) => {
  service.trackMedicalEvent("medical_view_step_app", {step})
}

tracking.launchApp = (activationCode: string, page: string) => {
  service.trackMedicalEvent("medical_launch_app", {activationCode, page})
}

export default tracking
